<style>

</style>
<template>
<div id="experience">

   <body>

<h3><font size="5">Experience</font></h3>
    <p> <strong>
      Student Staff - Florida Polytechnic University (Aug 2019 - Present)
      </strong>
      
    <br> • Work alongside Academic Success Coaches, assisting in general and academic support functions.
    <br> • Routine office duties such as photocopying, filing, computer work, making deliveries, and answering the telephone.
    <br> • Specific daily tasks and projects as assigned by the Chair and/or the Office Manager.
    <br> • Proficient in basic computer skills, i.e., word processing, spreadsheets, presentations, web sites, and creating/updating databases.

    </p>
    <p> <strong>
      CDO - MADD Technologies LLC (Jan 2018 - Present)
      </strong>

      <br> •	Conducted user requirements and developed and documented use cases along with test cases in the form of Given-When-Then. 
      <br> •	Lead the creative team and directed project completion.
      <br> •	Responsible for company brand identity.
      <br> •	Performed Project Manager responsibilities across all projects ensuring on time delivery.
      <br> •	Featured in local Florida newspaper as a Florida Polytechnic tech startup.
      <br> •	Technology Stack: AWS, Vue.js, C++, Java, Python, Git.
 <br>
      <ul>
        <a href="https://www.maddtechnologies.com/" target="_blank" rel="noopener">Madd Technologies</a>
      </ul>
    </p>
  

    <p> <strong>
      Entrepreneurship - Phoenix Flight Program (May 2020 - Aug 2020)
      </strong>
  
    <br> •	Applied the scientific methodology to validate or invalidate assumptions behind business ideas.
    <br> •	Applied Agile methodology and its pillars to manage my project coursework focusing on daily standups, project estimation, and sprint retrospective.
    <br> •	Applied full software development lifecycle (SDLC) focusing on continuous integration / continuous deployment (CICD).
    <br> •	Systematically applied STEM skills to creating a Minimal Viable Product (MVP) to satisfy program internship rubric. 
    </p>

</body>
</div>
</template>

<script>
   export default{

   }
</script>

<style scoped>
body {
    background: #767f6c;
    padding: 30px;
}
p{
    color: black;
    font-size: 20px;

}
ul {
  list-style-type: none;
  padding: 0;
}
</style>